var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0167 1.66675C6.95004 1.66675 4.4667 4.15008 4.4667 7.21675V8.96675C4.4667 9.53342 4.23337 10.3834 3.9417 10.8667L2.88337 12.6334C2.23337 13.7251 2.68337 14.9417 3.88337 15.3417C7.86777 16.6667 12.174 16.6667 16.1584 15.3417C16.4213 15.254 16.6611 15.1084 16.8602 14.9156C17.0593 14.7227 17.2124 14.4876 17.3084 14.2276C17.4044 13.9676 17.4408 13.6894 17.4148 13.4134C17.3888 13.1375 17.3012 12.8709 17.1584 12.6334L16.1 10.8667C15.8084 10.3834 15.575 9.52508 15.575 8.96675V7.21675C15.5667 4.16675 13.0667 1.66675 10.0167 1.66675Z",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.775 15.6833C12.775 17.2083 11.525 18.4583 9.99998 18.4583C9.24164 18.4583 8.54164 18.1417 8.04164 17.6417C7.54164 17.1417 7.22498 16.4417 7.22498 15.6833",
    stroke: "#333335",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.6ea3be3b.svg";
export { ForwardRef as ReactComponent };